import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-slide-toggle',
  templateUrl: './dynamic-slide-toggle.component.html',
  styleUrls: ['./dynamic-slide-toggle.component.css']
})
export class DynamicSlideToggleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
